import React from 'react';
import { arrayOf, shape, string, bool } from 'prop-types';
import Media from '../media';
import { Label } from '../../prop-types';
import classnames from 'classnames';

const namespace = 'ui-pdp-info-label';

const CreditsOfferInfoLabel = ({ contentRows, className = '', withMercadoCredits = false }) => {
  const computedNamespace = withMercadoCredits ? `${namespace}--b2c` : namespace;
  return (
    <div className={classnames(computedNamespace, className)}>
      {contentRows.map(({ label, icon }) => (
        <Media key={label} className={`${namespace}__row`} title={{ ...label, plain: true }} icon={icon} />
      ))}
    </div>
  );
};

CreditsOfferInfoLabel.propTypes = {
  className: string,
  withMercadoCredits: bool,
  contentRows: arrayOf(
    shape({
      label: Label,
      icon: shape({ id: string, color: string }),
    }),
  ).isRequired,
};

export default CreditsOfferInfoLabel;
